import { Truck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { LogisticsPage } from './pages/LogisticsPage'
import { LogisticsPipelinePage } from './pages/LogisticsPipelinePage'

/**
 * SPI Freight — carrier-agnostic inbound freight board (Sprint 15 origin
 * as TQL-only "Inbound Logistics"; unified across providers 2026-06).
 *
 * Backed by middleware `GET /api/freight/shipments` (unified
 * freight_shipments store) + `GET /api/freight/health` (per-provider
 * chips). Providers are configured at Settings → Freight Carriers —
 * adding a carrier requires no change here.
 *
 * Logistics overhaul Phase 2a (2026-07-08) added a Board view (kanban over
 * the freight_pipeline table, `GET/POST /api/freight/pipeline*`) alongside
 * the original flat tracking Table, plus a per-row work view at
 * `/logistics/$pipelineId`. Phase 2b (same day) added the quote/tender
 * actions to that work view — gated to the `operations_logistics` /
 * `admin` roles (`can_tender_freight` server-side).
 */
export default defineModule({
  id: 'logistics',
  name: 'SPI Freight',
  shortName: 'Freight',
  icon: Truck,
  navSection: 'logistics',
  navOrder: 50,
  urlNamespace: '/logistics',
  routes: [
    { path: '/', element: LogisticsPage, label: 'SPI Freight' },
    { path: '/$pipelineId', element: LogisticsPipelinePage, label: 'Freight pipeline' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g t',

  commandPaletteEntries: [
    {
      label: 'Go to SPI Freight',
      keywords: [
        'logistics',
        'tracking',
        'tql',
        'freight',
        'shipment',
        'inbound',
        'load',
        'global net',
        'gnl',
        '7l',
        'carrier',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g t',
    },
  ],
})
